<app-header></app-header>
<main class="pages howitworks">
    <!-- Header -->
    <section class="gradient-light">
        <div class="container pt-lg-5">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <!-- <h1 class="page-hero-title mt-3">How it works</h1> -->
                    <h1 alt="feedback application" class="h1-title mt-lg-4">C.A.A.G. Model</h1>
                    <p class="sub-text mt-3">CViewSurvey works on a proven C.A.A.G. model which allows you to collect actionable data, and helps you analyze it in a meaningful way. It lets you view your responses graphically and in real time ensuring 360<sup>&deg;</sup> assessment
                        and swift action delivery.
                    </p>
                    <div class="mt-lg-5 mt-0">
                        <button class="btn btn-success btn-lg px-5 text-uppercase" type="button" data-toggle="modal" data-target="#callBack" id="callback">REQUEST A DEMO</button>
                    </div>
                </div>
                <div class="col-md-6 ">
                    <div class="page-banner-img">
                        <img class="img-fluid w-100" alt="market Survey" src="assets/howitwork.svg">
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End Header -->

    <!-- Page Contain -->
    <section class="py-lg-5">
        <div class="container pb-lg-5">
            <div class="col-md-12">
                <h2 alt="customer satisfaction survey" class="h4-title section-title font-weight-bold text-center mb-4">How CViewSurvey App works?</h2>
            </div>
            <div class="">
                <p>CViewSurvey is a SaaS-based Web & Mobile application that provides digital transformation to traditional paper surveys and feedback for customer & employee experience, field & market research that helps you evaluate your customer's as
                    well as employee's loyalty.</p>
                <p>With our unique C.A.A.G. Collect, Analysis, Act & Grow approach; business & industry’s can create customized surveys on web, publish on app to collect unlimited response & review AI backed real-time data analytics on mobile & tablets anytime,
                    anywhere. Data collected when offline is securely stored in the device, which syncs to the cloud server when connected to any network.</p>
            </div>
        </div>
    </section>
    <!-- End Page Contain -->

    <!-- Tab Video Section -->
    <section class="bg-primary py-lg-5 mt-lg-5 position-relative">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="solution-video">
                        <!-- <video class="embed-responsive embed-responsive-16by9" autoplay [muted]="'muted'" controls loop>
                        <source class="embed-responsive-item" src="assets/video/how-cview-works.mp4" type="video/mp4">
                        Your browser does not support the video tag.
                      </video> -->
                        <iframe width="580" height="335" [src]="safeURL" frameborder="0" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End Tab Video Section -->
</main>
<app-footer></app-footer>